export default "__VITE_ASSET__hR2rZhVT__"